module.exports = __webpack_public_path__ + "img/estalagem06.0036cd61.jpg";